<template>
  <div class="shareholder">
    <h3>客户背景资料调查表</h3>
    <TableView
      :loading="loading"
      ref="backgroundTable"
      :columns="columns"
      :pagination="pageData"
      :data="tableData"
      v-on:handlePagination="handlePagination"
    >
      <template v-slot:action="{ tableRow }">
        <template v-if="permissions && permissions.includes('编辑')">
          <a-upload
            name="file"
            :multiple="false"
            action="/credit/customer/background/upload"
            :show-upload-list="false"
            :data="{
              id: tableRow.id,
              companyId: companyId,
            }"
            :headers="{ token }"
            @change="uploadChange"
          >
            <a href="javascript:void(0)">
              上传
            </a>
          </a-upload>
          <a-divider type="vertical" />
        </template>
        <a href="javascript:void(0)" @click="download(tableRow)">
          下载
        </a>
      </template>
    </TableView>
  </div>
</template>
<script>
import mixin from './mixinBackground'
import { donwloadBackground } from '../api'
import { mapGetters } from 'vuex'
import { TableView } from 'lxfintech-fe'
import { LOGIN_EXPIRED } from 'config/index'
import storage from 'good-storage'
export default {
  mixins: [mixin],
  name: 'create-form',
  props: ['customerDetail', 'permissions'],
  components: {
    TableView,
  },
  data() {
    return {
      loading: false,
      formLayout: 'vertical',
      tableData: [],
      pageData: {
        showTotal: total => `总共 ${total} 条`, //展示总条数
      },
      companyCode: '',
      companyId: '',
      fileList: [],
      headers: {
        authorization: 'authorization-text',
      },
    }
  },
  watch: {
    customerDetail: {
      handler(newValue) {
        this.tableData = newValue.backgrounds
      },
    },
  },
  computed: {
    ...mapGetters('app', ['company']),
    ...mapGetters('user', ['token']),
  },
  mounted() {
    this.companyId = this.$route.params.id
    this.getTableData()
  },
  methods: {
    // 企业地址信息
    getTableData() {
      if (this.customerDetail) {
        if (this.customerDetail.backgrounds[0]) {
          this.companyCode = this.customerDetail.base.code
          this.tableData = [...this.customerDetail.backgrounds]
        } else {
          this.tableData = [
            {
              id: '',
              name: '',
              updateTime: '',
            },
          ]
        }
      }
    },
    //客户背景资料调查表下载
    async download({ id }) {
      await donwloadBackground(id)
    },
    //分页
    handlePagination(pagination) {
      const { current, pageSize, total } = pagination
      this.pageData.current = current
      this.pageData.pageSize = pageSize
      this.pageData.total = total
      this._getTableData()
    },
    async uploadChange(data) {
      const {
        file: { response },
      } = data

      if (response && response.code === '0000') {
        this.$message.success('成功')
        await this.$emit('hanleDetail')
      } else {
        if (response && response.code == LOGIN_EXPIRED) {
          // 此时登录过期
          this.$message.error('登录过期，请重新登录')
          window.setTimeout(() => {
            storage.clear()
            this.$router.push('/login')
          }, 1000)
        }
      }
    },
  },
}
</script>
<style lang="less" scoped>
.shareholder {
  /deep/ .margin-left-20 {
    margin-left: 20px;
  }
  .client-center-home
    /deep/
    .ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header {
    line-height: 30px;
  }
  /deep/ .edit-btns {
    text-align: right;
    width: 98.5%;
  }
  /deep/.margin-bottom-20 {
    margin-bottom: 20px;
  }
  /deep/ .editable-row-operations a {
    margin-right: 8px;
  }
  /deep/ .shareholder-add-btn {
    margin-top: 20px;
    .editable-add-btn {
      width: 100%;
    }
  }
}
</style>
